import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, onSnapshot, query, where, doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { turkeyCities as TURKEY_CITIES } from '../data/turkeyCities';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const Reservation = () => {
    const { currentUser, dbUser } = useAuth();
    const [currentView, setCurrentView] = useState("listing");
    const [selectedField, setSelectedField] = useState(null);
    const [bookingStep, setBookingStep] = useState(1);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const [userInfo, setUserInfo] = useState({ name: "", surname: "", phone: "", email: "", address: "", city: "" });
    const [isProcessing, setIsProcessing] = useState(false);
    const [checkoutFormHtml, setCheckoutFormHtml] = useState("");
    const [dateList, setDateList] = useState([]);
    const [dynamicTimeRanges, setDynamicTimeRanges] = useState([]);

    const calculateTotalPrice = (depositAmount) => {
        const original = Number(depositAmount || 1500);
        // %3.5 komisyon (3 ile 4 arası) + 20 TL sabit ücret
        const commission = original * 0.035;
        const total = original + commission + 20;
        return Math.round(total);
    };

    const [ratings, setRatings] = useState({});
    const [userVotes, setUserVotes] = useState([]);

    const [selectedCity, setSelectedCity] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [fields, setFields] = useState([]);
    const [allBookings, setAllBookings] = useState([]);

    const generateDateList = () => {
        const dates = [];
        for (let i = 0; i < 10; i++) {
            const d = new Date();
            d.setDate(d.getDate() + i);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            dates.push({
                fullDate: d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' }),
                dayName: d.toLocaleDateString('tr-TR', { weekday: 'long' }),
                value: `${year}-${month}-${day}`
            });
        }
        return dates;
    };

    useEffect(() => {
        // 1. ONAYLANMIŞ VEYA YETKİLENDİRİLMİŞ SAHALARI ÇEK
        const qTesisler = query(collection(db, "tesisler"), where("status", "in", ["approved", "authorized"]));
        const unsubTesisler = onSnapshot(qTesisler, (snapshot) => {
            const tesisData = snapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    fieldName: data.fieldName || data.name || "Halı Saha"
                };
            });
            setFields(tesisData);
        });

        // 2. TÜM REZERVASYONLARI ÇEK (Doluluk kontrolü için)
        const unsubRezervasyonlar = onSnapshot(collection(db, "rezervasyonlar"), (snapshot) => {
            const resData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAllBookings(resData);
        });

        const savedRatings = JSON.parse(localStorage.getItem('sahalive_ratings')) || {};
        setRatings(savedRatings);
        const savedVotes = JSON.parse(localStorage.getItem('sahalive_user_votes')) || [];
        setUserVotes(savedVotes);

        return () => { unsubTesisler(); unsubRezervasyonlar(); };
    }, []);

    const handleRate = (fieldId, score) => {
        if (userVotes.includes(fieldId)) return alert("⚠️ Bu sahaya daha önce puan verdiniz!");
        const currentRating = ratings[fieldId] || { sum: 0, count: 0 };
        const newRating = { sum: currentRating.sum + score, count: currentRating.count + 1 };
        const newRatings = { ...ratings, [fieldId]: newRating };
        setRatings(newRatings);
        localStorage.setItem('sahalive_ratings', JSON.stringify(newRatings));
        setUserVotes([...userVotes, fieldId]);
        localStorage.setItem('sahalive_user_votes', JSON.stringify([...userVotes, fieldId]));
        alert(`Teşekkürler! ${score} Yıldız verdiniz. ⭐`);
    };

    const generateDynamicHours = (field) => {
        if (!field) return [];
        const start = parseInt((field.openTime || "10:00").split(':')[0]);
        let end = parseInt((field.closeTime || "24:00").split(':')[0]);
        if (end <= start) end += 24;
        const ranges = [];
        for (let i = start; i < end; i++) {
            const s = i % 24 < 10 ? `0${i % 24}` : i % 24;
            const e = (i + 1) % 24 < 10 ? `0${(i + 1) % 24}` : (i + 1) % 24;
            ranges.push(`${s}:00 - ${e}:00`);
        }
        return ranges;
    };

    const filteredFields = fields.filter(field => {
        const cityMatch = selectedCity === "" || (field.city || "").toLowerCase() === selectedCity.toLowerCase();
        const districtMatch = selectedDistrict === "" || (field.district || "").toLowerCase() === selectedDistrict.toLowerCase();
        return cityMatch && districtMatch;
    });

    // Rastgele görsel seçici (ID bazlı tutarlı ama farklı sahalar için farklı)
    const getFallbackImage = (id) => {
        const images = [
            "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&q=80",
            "https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=800&q=80",
            "https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=800&q=80",
            "https://images.unsplash.com/photo-1518091043644-c1d445bcc97a?w=800&q=80",
            "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=800&q=80"
        ];
        const index = parseInt(id.substring(0, 3), 36) % images.length || 0;
        return images[index];
    };

    const isSlotBooked = (time) => {
        if (!selectedField || !selectedDate || !time) return false;
        return allBookings.some(booking =>
            booking.fieldId === selectedField.id &&
            booking.date === selectedDate &&
            (booking.time === time || booking.timeSlot === time) &&
            (booking.status === "confirmed" || booking.status === "payment_pending" || booking.status === "blocked" || booking.status === "pending_approval" || booking.status === "manuel_booked")
        );
    };

    const isSlotLocked = (time) => {
        if (!selectedField || !selectedDate || !time) return false;
        const lock = allBookings.find(booking =>
            booking.fieldId === selectedField.id &&
            booking.date === selectedDate &&
            (booking.time === time || booking.timeSlot === time) &&
            booking.status === "processing"
        );
        if (!lock) return false;

        // Kilidin süresi dolmuş mu kontrol et (10 dakika)
        const now = new Date();
        const lockTime = lock.lockedUntil?.toDate();
        if (lockTime && now > lockTime) return false;

        return true;
    };

    const handleTimeSelection = async (time) => {
        if (isProcessing) return;
        setIsProcessing(true);

        const lockDocId = `${selectedField.id}_${selectedDate}_${time.replace(/:/g, '')}`;
        const lockRef = doc(db, "rezervasyonlar", lockDocId);

        try {
            await runTransaction(db, async (transaction) => {
                const lockDoc = await transaction.get(lockRef);

                const now = new Date();
                if (lockDoc.exists()) {
                    const data = lockDoc.data();
                    const lockedUntil = data.lockedUntil?.toDate();

                    // Eğer slot doluysa veya geçerli bir kilit varsa hata ver
                    if (data.status === "confirmed" || data.status === "pending_approval" || data.status === "payment_pending" || data.status === "manuel_booked" || data.status === "blocked" || (data.status === "processing" && lockedUntil && now < lockedUntil)) {
                        throw new Error("Bu saat şu an başka bir kullanıcı tarafından işlem görüyor veya dolu.");
                    }
                }

                // Kilidi koy
                transaction.set(lockRef, {
                    fieldId: selectedField.id,
                    fieldName: selectedField.fieldName,
                    date: selectedDate,
                    timeSlot: time,
                    status: "processing",
                    lockedUntil: new Date(now.getTime() + 10 * 60 * 1000), // 10 Dakika Kilit
                    createdAt: serverTimestamp()
                }, { merge: true });
            });

            setSelectedTime(time);
            setBookingStep(3);
            setIsProcessing(false);
        } catch (err) {
            setIsProcessing(false);
            alert(err.message || "Bu saat şu an kilitli, lütfen başka bir saat seçin.");
        }
    };

    const goToBooking = (field) => {
        setSelectedField(field);
        setDateList(generateDateList());
        setDynamicTimeRanges(generateDynamicHours(field));
        setSelectedDate("");
        setSelectedTime("");
        setCurrentView("booking");
        setBookingStep(1);
        window.scrollTo(0, 0);
    };

    const goBackToList = () => { 
        setCurrentView("listing"); 
        setSelectedField(null); 
        setBookingStep(1); 
        setUserInfo({ name: "", surname: "", phone: "", email: "", address: "", city: "" }); 
        setCheckoutFormHtml("");
    };

    const handlePaymentConfirm = async () => {
        if (isProcessing) return;
        setIsProcessing(true);

        const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

        try {
            // 1. Ödemeyi Başlat (Backend'den Iyzico formunu al)
            const response = await axios.post(`${API_URL}/api/payment/initialize`, {
                reservationData: {
                    fieldId: selectedField.id,
                    fieldName: selectedField.fieldName,
                    date: selectedDate,
                    timeSlot: selectedTime,
                    price: calculateTotalPrice(selectedField.depositAmount),
                    userId: currentUser?.uid || dbUser?._id || null
                },
                buyerData: {
                    ...userInfo,
                    uid: currentUser?.uid || dbUser?._id || 'guest_' + Date.now(),
                    email: currentUser?.email || dbUser?.email || 'misafir@sahalive.com',
                    city: selectedField.city || 'Istanbul',
                    address: selectedField.district ? `${selectedField.district} Sahası` : 'Halı Saha Mah. No:1'
                }
            });

            if (response.data.status === 'success') {
                setCheckoutFormHtml(response.data.checkoutFormContent);
                // Iyzico scriptini çalıştır
                setTimeout(() => {
                    const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/g;
                    let match;
                    while ((match = scriptRegex.exec(response.data.checkoutFormContent)) !== null) {
                        const scriptContent = match[1];
                        const scriptTag = document.createElement('script');
                        scriptTag.innerHTML = scriptContent;
                        document.body.appendChild(scriptTag);
                    }
                }, 100);
            } else {
                alert("Ödeme başlatılamadı: " + response.data.message);
            }
        } catch (err) {
            console.error("Payment Init Error:", err);
            alert("Bir hata oluştu! Sunucuyla bağlantı kurulamadı.");
        } finally {
            setIsProcessing(false);
        }
    };

    if (currentView === "listing") {
        return (
            <div className="container py-5">
                <style>
                    {`
                        .force-horizontal {
                            display: flex !important;
                            flex-direction: row !important;
                            flex-wrap: nowrap !important;
                            justify-content: center !important;
                            width: 100% !important;
                        }
                        .force-horizontal i {
                            flex-shrink: 0 !important;
                        }
                    `}
                </style>
                <div className="mb-5 text-center">
                    <h2 className="fw-bold d-flex justify-content-center align-items-center">Rezervasyon Yap</h2>
                    <p className="text-muted">Bulunduğun konumu seç, en yakın sahayı kirala.</p>
                </div>

                <div className="card shadow-sm border-0 p-4 mb-5 rounded-4 bg-light">
                    <div className="row g-3">
                        <div className="col-md-5"><label className="fw-bold small mb-1 ms-1">İl Seçiniz</label><select className="form-select p-3 border-0 shadow-sm" value={selectedCity} onChange={(e) => { setSelectedCity(e.target.value); setSelectedDistrict(""); }}><option value="">Tüm Türkiye</option>{Object.keys(TURKEY_CITIES).map((city) => (<option key={city} value={city}>{city}</option>))}</select></div>
                        <div className="col-md-5"><label className="fw-bold small mb-1 ms-1">İlçe Seçiniz</label><select className="form-select p-3 border-0 shadow-sm" value={selectedDistrict} onChange={(e) => setSelectedDistrict(e.target.value)} disabled={!selectedCity}><option value="">Tümü</option>{selectedCity && TURKEY_CITIES[selectedCity].map((district) => (<option key={district} value={district}>{district}</option>))}</select></div>
                        <div className="col-md-2 d-flex align-items-end"><button className="btn btn-warning w-100 p-3 fw-bold shadow-sm"><i className="fas fa-search me-2"></i> Listele</button></div>
                    </div>
                </div>

                <div className="row">
                    {filteredFields.length > 0 ? filteredFields.map((field) => {
                        const fieldRating = ratings[field.id];
                        const averageScore = fieldRating ? (fieldRating.sum / fieldRating.count) : 0;
                        const hasVoted = userVotes.includes(field.id);

                        return (
                            <div key={field.id} className="col-md-4 mb-4">
                                <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden" style={{ transition: "0.3s" }}>
                                    <div className="position-relative">
                                        <img
                                            src={field.imageUrl || field.image || getFallbackImage(field.id)}
                                            className="card-img-top"
                                            alt={field.fieldName}
                                            style={{ height: "220px", objectFit: "cover" }}
                                            onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=800&q=80" }}
                                        />
                                        <div className="position-absolute top-0 end-0 m-3"><span className="badge bg-warning text-dark fs-6 py-2 px-3 rounded-pill shadow-sm fw-bold">{Number(field.depositAmount || 1500) + 50} TL</span></div>
                                    </div>
                                    <div className="card-body p-4 text-center">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <h5 className="card-title fw-bold mb-0 text-start">{field.fieldName}</h5>
                                            <span className="badge bg-light text-dark border small">{field.openTime || "10:00"} - {field.closeTime || "24:00"}</span>
                                        </div>

                                        {/* YENİ: TELEFON NUMARASI */}
                                        <p className="text-muted small mb-2 text-start">
                                            <i className="fas fa-map-marker-alt text-danger me-1"></i> {field.city} / {field.district} <br />
                                            <i className="fas fa-phone-alt text-primary me-1 mt-1"></i> <span className="fw-bold">{field.phone}</span>
                                        </p>

                                        {/* YENİ: TESİS İMKANLARI (TİK / ÇARPI TASARIMI) */}
                                        <div className="d-flex flex-wrap justify-content-center gap-2 mb-3 bg-light p-2 rounded-3">
                                            {[
                                                { key: 'dus', label: 'Duş', icon: '🚿' },
                                                { key: 'otopark', label: 'Otopark', icon: '🅿️' },
                                                { key: 'kantin', label: 'Kantin', icon: '☕' },
                                                { key: 'krampon', label: 'Krampon', icon: '👟' },
                                                { key: 'eldiven', label: 'Eldiven', icon: '🧤' },
                                                { key: 'servis', label: 'Servis', icon: '🚐' }
                                            ].map((item) => {
                                                const hasIt = field.amenities?.[item.key];
                                                return (
                                                    <div key={item.key} className="d-flex align-items-center bg-white px-2 py-1 rounded-2 shadow-sm border" style={{ fontSize: '0.70rem' }}>
                                                        <span className="me-1">{item.icon}</span>
                                                        <span className="me-1 fw-bold text-dark">{item.label}</span>
                                                        {hasIt ? (
                                                            <i className="fas fa-check-circle text-success" style={{ fontSize: '0.75rem' }}></i>
                                                        ) : (
                                                            <i className="fas fa-times-circle text-danger" style={{ fontSize: '0.75rem' }}></i>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        <div className="mb-3">
                                            <div className="force-horizontal gap-1">
                                                {[1, 2, 3, 4, 5].map(star => (
                                                    <i key={star} className={`fas fa-star ${star <= Math.round(averageScore) ? 'text-warning' : 'text-secondary opacity-25'}`}
                                                        style={{ cursor: hasVoted ? 'default' : 'pointer', fontSize: "1.3rem" }}
                                                        onClick={() => handleRate(field.id, star)}
                                                        title={hasVoted ? "Puan verildi" : `${star} Puan Ver`}
                                                    ></i>
                                                ))}
                                            </div>
                                        </div>

                                        <button className="btn btn-dark w-100 py-2 rounded-3 fw-bold shadow-sm" onClick={() => goToBooking(field)}>Randevu Al</button>
                                    </div>
                                </div>
                            </div>
                        );
                    }) : (
                        <div className="col-12 text-center py-5"><h4 className="fw-bold text-muted">Bu konumda henüz onaylı saha bulunmuyor.</h4></div>
                    )}
                </div>
            </div>
        );
    }

    // Booking (Randevu) ekranı da aynı şekilde devam ediyor, yer kaplamaması için özetledim
    if (currentView === "booking" && selectedField) {
        return (
            <div className="container-fluid min-vh-100 bg-light d-flex justify-content-center align-items-start py-3 py-md-5">
                <style>
                    {`
                        .date-scroll-container {
                            display: flex !important;
                            flex-direction: column !important;
                            gap: 10px !important;
                            width: 100% !important;
                        }
                        .time-grid-container {
                            display: grid !important;
                            grid-template-columns: repeat(3, 1fr) !important;
                            gap: 8px !important;
                            width: 100% !important;
                        }
                        @media (max-width: 767px) {
                            .booking-card-body {
                                padding: 1.5rem !important;
                            }
                        }
                    `}
                </style>
                <div className="card shadow-lg border-0 rounded-4 overflow-hidden" style={{ maxWidth: "900px", width: "100%" }}>
                    <div className="row g-0">
                        <div className="col-md-4 position-relative">
                            <img
                                src={selectedField.imageUrl || selectedField.image || getFallbackImage(selectedField.id)}
                                className="h-100 w-100"
                                style={{ objectFit: "cover", minHeight: "200px" }}
                                alt="Saha"
                                onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=800&q=80" }}
                            />
                            <div className="position-absolute bottom-0 start-0 p-4 text-white bg-dark bg-opacity-75 w-100">
                                <h3 className="fw-bold mb-0">{selectedField.fieldName}</h3>
                                <p className="small mb-0">{selectedField.city} / {selectedField.district}</p>
                                <p className="small mb-0 fw-bold text-warning mt-1"><i className="fas fa-phone-alt me-1"></i>{selectedField.phone}</p>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="card-body p-md-5 booking-card-body">
                                <button className="btn btn-outline-secondary btn-sm mb-4" onClick={goBackToList}>← Geri Dön</button>
                                {bookingStep === 1 && (
                                    <div className="animate__animated animate__fadeIn">
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h4 className="fw-bold mb-0">Adım 1: Tarih Seçin</h4>
                                            <span className="badge bg-dark">1 / 4</span>
                                        </div>
                                        <div className="date-scroll-container pb-3 mb-3">
                                            {dateList.map((dateObj, index) => (
                                                <button key={index}
                                                    className={`btn px-4 py-3 rounded-4 border d-flex justify-content-between align-items-center ${selectedDate === dateObj.value ? 'btn-warning text-dark border-warning fw-bold shadow' : 'btn-white bg-white text-dark shadow-sm'}`}
                                                    onClick={() => {
                                                        setSelectedDate(dateObj.value);
                                                        setSelectedTime(null);
                                                        setBookingStep(2);
                                                    }} style={{ width: "100%", transition: "0.2s" }}>
                                                    <div className="text-start">
                                                        <div className="fw-bold" style={{ fontSize: "1rem" }}>{dateObj.fullDate}</div>
                                                        <div className="small opacity-75">{dateObj.dayName}</div>
                                                    </div>
                                                    <i className="fas fa-chevron-right opacity-50"></i>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {bookingStep === 2 && (
                                    <div className="animate__animated animate__fadeIn">
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <div>
                                                <button className="btn btn-sm btn-outline-dark me-2" onClick={() => setBookingStep(1)}><i className="fas fa-chevron-left"></i></button>
                                                <h4 className="fw-bold d-inline-block mb-0">Adım 2: Saat Seçin</h4>
                                            </div>
                                            <span className="badge bg-dark">2 / 4</span>
                                        </div>
                                        <p className="text-muted small mb-3">Seçilen Tarih: <b>{dateList.find(d => d.value === selectedDate)?.fullDate}</b></p>
                                        <div className="time-grid-container">
                                            {dynamicTimeRanges.map((t, i) => {
                                                const booked = isSlotBooked(t);
                                                const locked = isSlotLocked(t);
                                                return (
                                                    <button
                                                        key={i}
                                                        disabled={booked || locked || isProcessing}
                                                        className={`btn py-3 fw-bold border-0 shadow-sm ${booked ? 'btn-danger' : locked ? 'btn-secondary opacity-50' : selectedTime === t ? 'btn-success text-white' : 'btn-outline-dark'}`}
                                                        style={{ fontSize: '0.75rem', padding: '12px 1px', width: '100%' }}
                                                        onClick={() => handleTimeSelection(t)}
                                                    >
                                                        {booked ? "DOLU" : locked ? "İŞLEMDE" : isProcessing && selectedTime === t ? "..." : t}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {bookingStep === 3 && (
                                    <div className="animate__animated animate__fadeIn">
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <div>
                                                <button className="btn btn-sm btn-outline-dark me-2" onClick={() => setBookingStep(2)}><i className="fas fa-chevron-left"></i></button>
                                                <h4 className="fw-bold d-inline-block mb-0">Adım 3: Bilgileriniz</h4>
                                            </div>
                                            <span className="badge bg-dark">3 / 4</span>
                                        </div>
                                        <div className="bg-light p-3 rounded-3 mb-4 small">
                                            <div className="d-flex justify-content-between mb-1"><span>Tarih:</span> <b>{dateList.find(d => d.value === selectedDate)?.fullDate}</b></div>
                                            <div className="d-flex justify-content-between"><span>Saat:</span> <b>{selectedTime}</b></div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label small fw-bold">Adınız</label>
                                            <input className="form-control p-3 bg-white border-0 shadow-sm" placeholder="Ad" value={userInfo.name} onChange={e => setUserInfo({ ...userInfo, name: e.target.value })} />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label small fw-bold">Soyadınız</label>
                                            <input className="form-control p-3 bg-white border-0 shadow-sm" placeholder="Soyad" value={userInfo.surname} onChange={e => setUserInfo({ ...userInfo, surname: e.target.value })} />
                                        </div>
                                        <div className="mb-4">
                                            <label className="form-label small fw-bold">Telefon Numaranız</label>
                                            <input className="form-control p-3 bg-white border-0 shadow-sm" placeholder="Örn: 05xx xxx xx xx" value={userInfo.phone} onChange={e => setUserInfo({ ...userInfo, phone: e.target.value })} />
                                        </div>
                                        <button className="btn btn-warning w-100 py-3 fw-bold shadow-sm rounded-4" onClick={() => {
                                            const phoneClean = userInfo.phone.replace(/\s/g, '');
                                            if (!userInfo.name || userInfo.name.length < 2) return alert("Lütfen geçerli bir ad giriniz.");
                                            if (!userInfo.surname || userInfo.surname.length < 2) return alert("Lütfen geçerli bir soyad giriniz.");
                                            if (!/^05[0-9]{9}$/.test(phoneClean)) return alert("Lütfen geçerli bir telefon numarası giriniz (Örn: 05xx xxx xx xx).");
                                            setBookingStep(4);
                                        }}>
                                            Devam Et <i className="fas fa-chevron-right ms-2"></i>
                                        </button>
                                    </div>
                                )}

                                {bookingStep === 4 && (
                                    <div className="animate__animated animate__fadeIn text-center">
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <button className="btn btn-sm btn-outline-dark" onClick={() => setBookingStep(3)}><i className="fas fa-chevron-left"></i></button>
                                            <h4 className="fw-bold mb-0">Son Adım: Ödeme</h4>
                                            <span className="badge bg-dark">4 / 4</span>
                                        </div>

                                        <div className="card border-0 bg-light p-4 rounded-4 mb-4">
                                            <h3 className="display-5 fw-bold text-dark mb-2">{calculateTotalPrice(selectedField.depositAmount)} TL</h3>
                                            <p className="text-muted small fw-bold mb-3">Online Kapora & Hizmet Bedeli</p>
                                            
                                            <div className="border-top pt-3 text-start small">
                                                <div className="d-flex justify-content-between mb-1">
                                                    <span className="text-muted">Halı Saha Kapora Bedeli:</span>
                                                    <span className="fw-semibold text-dark">{Number(selectedField.depositAmount || 1500)} TL</span>
                                                </div>
                                                <div className="d-flex justify-content-between mb-1">
                                                    <span className="text-muted">Aracı ve Komisyon Bedeli (%3.5):</span>
                                                    <span className="fw-semibold text-dark">{Math.round(Number(selectedField.depositAmount || 1500) * 0.035)} TL</span>
                                                </div>
                                                <div className="d-flex justify-content-between mb-1">
                                                    <span className="text-muted">Hizmet Bedeli:</span>
                                                    <span className="fw-semibold text-dark">20 TL</span>
                                                </div>
                                                <div className="d-flex justify-content-between border-top pt-2 mt-2 fw-bold text-dark fs-6">
                                                    <span>Toplam Ödenecek:</span>
                                                    <span className="text-primary">{calculateTotalPrice(selectedField.depositAmount)} TL</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-start small mb-4 bg-white p-3 rounded-3 border">
                                            <div className="mb-1"><b>Saha:</b> {selectedField.fieldName}</div>
                                            <div className="mb-1"><b>Randevu:</b> {dateList.find(d => d.value === selectedDate)?.fullDate} | {selectedTime}</div>
                                            <div className="mb-3"><b>Müşteri:</b> {userInfo.name} {userInfo.surname}</div>

                                            {!checkoutFormHtml ? (
                                                <div className="mt-4 text-center p-4 border rounded-4 bg-light">
                                                    <h5 className="fw-bold mb-3">Ödeme Yöntemi: Kredi/Banka Kartı</h5>
                                                    <p className="text-muted small mb-4">Iyzico güvencesiyle 3D Secure ödeme yapacaksınız.</p>
                                                    <button 
                                                        className="btn btn-warning w-100 py-3 rounded-4 fw-bold shadow-sm"
                                                        disabled={isProcessing}
                                                        onClick={handlePaymentConfirm}
                                                    >
                                                        {isProcessing ? "Lütfen Bekleyin..." : "ÖDEME FORMUNU GETİR"}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="mt-4 animate__animated animate__fadeIn">
                                                    <div id="iyzipay-checkout-form" className="responsive"></div>
                                                    <div dangerouslySetInnerHTML={{ __html: checkoutFormHtml }} />
                                                </div>
                                            )}
                                        </div>
                                        
                                        {!checkoutFormHtml && <p className="text-muted mt-3" style={{ fontSize: '0.7rem' }}>Güvenli 256-bit SSL sertifikası ile korunmaktadır.</p>}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Reservation;